import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-request-detail-empty',
    templateUrl: './request-detail-empty.component.html',
    styleUrls: ['./request-detail-empty.component.scss'],
    imports: [TranslateModule],
})
export class RequestDetailEmptyComponent {}
